import { useForceUpdate, useIsomorphicLayoutEffect } from '../helpers';
import { useRef } from 'react';
/**
 *
 * @template TInput Input value within Observable.
 *
 * @param useCustomEffect useEffect or useLayoutEffect
 * @param args collected arguments
 */
export function useSubscriptionInternal(useCustomEffect, args) {
    var forceUpdate = useForceUpdate();
    var argsRef = useRef(args);
    var errorRef = useRef();
    var subscriptionRef = useRef();
    // Update the latest observable and callbacks
    // synchronously after render being committed
    useIsomorphicLayoutEffect(function () {
        argsRef.current = args;
    });
    useCustomEffect(function () {
        errorRef.current = null;
        // keep in closure for checking staleness
        var input$ = argsRef.current[0];
        var subscription = input$.subscribe({
            next: function (value) {
                if (input$ !== argsRef.current[0]) {
                    // stale observable
                    return;
                }
                if (argsRef.current[1]) {
                    return argsRef.current[1](value);
                }
            },
            error: function (error) {
                if (input$ !== argsRef.current[0]) {
                    // stale observable
                    return;
                }
                if (argsRef.current[2]) {
                    errorRef.current = null;
                    return argsRef.current[2](error);
                }
                errorRef.current = error;
                forceUpdate();
            },
            complete: function () {
                if (input$ !== argsRef.current[0]) {
                    // stale observable
                    return;
                }
                if (argsRef.current[3]) {
                    return argsRef.current[3]();
                }
            }
        });
        subscriptionRef.current = subscription;
        return function () {
            subscription.unsubscribe();
        };
    }, [args[0]]);
    if (errorRef.current) {
        // Let error boundary catch the error
        throw errorRef.current;
    }
    return subscriptionRef;
}
//# sourceMappingURL=use-subscription-internal.js.map